/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ barcode: NonNullable<unknown> }} Pos_Barcode_Not_Found_DescInputs */

const vi_pos_barcode_not_found_desc = /** @type {(inputs: Pos_Barcode_Not_Found_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã vạch "${i?.barcode}" không khớp sản phẩm nào trong hệ thống.`)
};

/**

* @param {Pos_Barcode_Not_Found_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_barcode_not_found_desc = /** @type {((inputs: Pos_Barcode_Not_Found_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Barcode_Not_Found_DescInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_barcode_not_found_desc(inputs)
});